var soto;
(function ($) {
  "use strict";
  soto = (function () {
    return {
      init: function () {
        // Header
        this.promotionalMessage();
        this.fixedHeader();
        this.headerSearch();
        this.cart();
        this.cartUpsell();
        this.popupNewsletter();
        this.mobileMenu();

        // Footer
        this.parallaxFooter();

        // Home
        this.slideshow();
        this.shopPlants();
        this.exploreCollectionProducts();
        this.lookbook();
        this.brands();
        this.latestNews();
        this.faq();

        // Blog
        this.blog();

        // Account
        this.account();

        // Search
        this.search();

        // Collection
        this.collection();
        this.collectionFilter();
        this.collectionSlider();
        this.collectionSlider2();

        // Product
        if ($(".product-template").length > 0) {
          this.productImages();
          this.productAddToBag();
          this.productForm();
          this.upsellProduct();
          this.relatedProducts();
          this.productBundlePurchase();
          //this.stickyAddToCart();
        }
        this.productQuantity();
        this.productRequiredEnquiry();
        this.attachAddToCartHandler();

        // Utilities
        this.video();
        this.accordion();
        this.choosenSelect();
        this.aos();
        this.matchHeight();
      },

      // Header
      promotionalMessage: function () {
        $('.js-carousel-promotional-message').owlCarousel({
          loop: true,
          margin: 8,
          nav: false,
          items: 1,
          autoplay: true
        })
      },

      fixedHeader: function () {
        var headerHeight = 0;
        $(window).scroll(function () {
          var scrollTop = $(window).scrollTop();
          if (scrollTop > $(".js-promotional-message").outerHeight()) {
            if (headerHeight == 0) {
              headerHeight = $(".js-header-container").outerHeight();
            }
            $(".js-header").css("height", headerHeight).addClass("fixed");
          } else {
            $(".js-header").removeClass("fixed");
          }
        });
      },

      headerSearch: function () {
        $(".js-open-search").click(function () {
          $(".js-search").toggleClass("active");
          return false;
        });
        $(".js-search-counter").each(function () {
          var href = $(this).attr("data-url");
          $(this).load(href + ' #search-counter', function () {

          });
        });
      },

      cart: function () {
        $("body").on("click", ".js-open-cart", function () {
          $(".js-cart").addClass("active");
          $("body").addClass("cart-open");
          return false;
        });

        $("body").on("click", ".js-close-cart", function () {
          $(".js-cart").removeClass("active");
          $("body").removeClass("cart-open");
          return false;
        });

        $("body").on("click", ".js-change-quantity", function () {
          var $btn = $(this);
          var quantity = parseInt($btn.attr("data-quantity"));
          var id = parseInt($btn.attr("data-variant-id"));
          var $cartItem = $btn.closest('.cart-item');

          if (quantity === 0) {
            $cartItem.addClass("is-loading");
          }

          var $qtyDisplay = $btn.closest('.cart-item__quantity').find('.qty-display');
          if (quantity !== 0) {
            $qtyDisplay.addClass("is-loading");
          }

          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            dataType: 'json',
            data: { id: id, quantity: quantity },
            success: function () {
              // if (quantity === 0) {
              //   $cartItem.slideUp(250, function() {
              //     soto.refreshCart();
              //   });
              // } else {
              // }
              soto.refreshCart();
              $cartItem.removeClass("is-loading");
            },
            error: function (response) {
              var errorMessage = response.responseJSON
                ? response.responseJSON.description
                : theme.strings.cartError;
              alert(errorMessage);
              $cartItem.removeClass("is-loading");
              $qtyDisplay.removeClass("is-loading");
              soto.refreshCart();
            }
          });
          return false;
        });

        $("body").on("click", ".js-cart-note-switcher", function () {
          if ($(".js-cart-note-switcher").is(":checked")) {
            $(".js-cart-note").removeClass("d-none");
          } else {
            $(".js-cart-note").addClass("d-none");
          }
        });

        $("body").on("click", "#cartCheckoutBtn", function () {
          $(".cart__checkout-btn").addClass("is-loading")
          setTimeout(function () {
            $(".cart__checkout-btn").removeClass("is-loading")
          }, 4000);
        });        
      },

      cartUpsell: function () {
        $(".js-carousel-upsell-cart-products").owlCarousel({
          loop: true,
          margin: 25,
          nav: true,
          navText: ['<svg><circle class="outer" cx="16" cy="16" r="16" transform="rotate(-90, 16, 16)"></circle></svg>', '<svg><circle class="outer" cx="16" cy="16" r="16" transform="rotate(-90, 16, 16)"></circle></svg>'],
          dots: false,
          items: 4,
          autoplay: false,
          responsive: {
            0: {
              items: 2
            },
            410: {
              items: 3
            },
            768: {
              items: 4
            }
          }
        }).on("dragged.owl.carousel", function (event) {
          $('.js-carousel-upsell-cart-products .owl-next').removeClass("active");
        });
        $('body').on('animationend webkitAnimationEnd oAnimationEnd', '.js-carousel-upsell-cart-products .owl-next svg circle', function () {
          $('.js-carousel-upsell-cart-products').trigger('next.owl.carousel');
          $('.js-carousel-upsell-cart-products .owl-next').removeClass("active");
          setTimeout(function () {
            $('.js-carousel-upsell-cart-products .owl-next').addClass("active");
          }, 50);
        });
        $('body').on('click', '.js-carousel-upsell-cart-products .owl-next, .js-carousel-upsell-cart-products .owl-prev', function () {
          $('.js-carousel-upsell-cart-products .owl-next').removeClass("active");
        });
        setTimeout(function () {
          $(".js-carousel-upsell-cart-products .owl-next").addClass("active");
        }, 200);
      },

      popupNewsletter: function () {
        if ($(".js-popup-newsletter").length > 0) {
          if (!$.cookie('newsletter')) {
            setTimeout(function () {
              $(".js-popup-newsletter").addClass("active");
            }, $(".js-popup-newsletter").attr("data-show-after"));
          } else {
            $(".js-popup-newsletter").hide();
          }

          $(".js-close-popup-newsletter").click(function () {
            $.cookie('newsletter', 'true', { expires: 72000 });
            $(".js-popup-newsletter").removeClass("active");
            return false;
          });
        }
      },

      mobileMenu: function () {
        // The pinned header + full-height drawer cover the screen, so overflow:hidden alone
        // freezes the background. No reposition/scroll-restore is needed, which avoids the
        // unwanted jump when closing.
        function lockBackgroundScroll() {
          document.body.classList.add("mobile-menu-open");
        }
        function unlockBackgroundScroll() {
          document.body.classList.remove("mobile-menu-open");
        }
        function closeMobileMenu() {
          $(".js-mobile-menu").removeClass("active");
          $(".js-icon-open-menu").removeClass("d-none");
          $(".js-icon-close-menu").addClass("d-none");
          unlockBackgroundScroll();
        }
        $(".js-open-mobile-menu").click(function () {
          if ($(".js-mobile-menu").hasClass("active")) {
            closeMobileMenu();
          } else {
            // Drawer is glued just below the header via CSS (top:100%); the header is pinned
            // to the top while open, so no JS positioning is needed.
            $(".js-mobile-menu").addClass("active");
            $(".js-icon-open-menu").addClass("d-none");
            $(".js-icon-close-menu").removeClass("d-none");
            lockBackgroundScroll();
          }
          return false;
        });
        $(".js-open-mobile-menu-second-level").click(function (e) {
          var width = $(this).outerWidth() * 0.8;
          var clickedPosition = e.pageX - $(this).offset().left;
          if (clickedPosition > width) {
            var id = $(this).attr("data-id");
            $(".js-mobile-menu-first-level").addClass("d-none");
            $(".js-mobile-menu-second-level").addClass("d-none");
            $(".js-mobile-menu-second-level[data-id='" + id + "']").removeClass("d-none");
            return false;
          }
        });
        $(".js-go-to-mobile-menu-first-level").click(function () {
          $(".js-mobile-menu-first-level").removeClass("d-none");
          $(".js-mobile-menu-second-level").addClass("d-none");
          return false;
        });
        $(".js-open-mobile-sub-menu").click(function (e) {
          var width = $(this).outerWidth() * 0.8;
          var clickedPosition = e.pageX - $(this).offset().left;
          if (clickedPosition > width) {
            $(".js-open-mobile-sub-menu").removeClass("active");
            $(this).addClass("active");
            $(".js-mobile-sub-menu").addClass("d-none");
            $(this).parent().find(".js-mobile-sub-menu").removeClass("d-none");
            return false;
          }
        });
      },

      // Footer
      parallaxFooter: function () {
        $(window).scroll(function () {
          var scrollTop = $(window).scrollTop() + $(window).outerHeight();
          if (scrollTop > $(".js-footer-parallax-space").offset().top) {
            $(".js-footer-parallax").addClass("active");
          } else {
            $(".js-footer-parallax").removeClass("active");
          }
        });
      },

      // Home
      slideshow: function () {
        $('.js-slideshow').owlCarousel({
          items: 1,
          margin: 0,
          nav: true,
          loop: false,
          navText: ['<svg><circle class="outer" cx="16" cy="16" r="16" transform="rotate(-90, 16, 16)"></circle></svg>', '<svg><circle class="outer" cx="16" cy="16" r="16" transform="rotate(-90, 16, 16)"></circle></svg>'],
          animateOut: 'fadeOut',
          animateIn: 'fadeIn'
        }).on("dragged.owl.carousel", function (event) {
          $('.js-slideshow .owl-next').removeClass("active");
        });
        $('body').on('animationend webkitAnimationEnd oAnimationEnd', '.js-slideshow .owl-next svg circle', function () {
          $('.js-slideshow').trigger('next.owl.carousel');
          $('.js-slideshow .owl-next').removeClass("active");
          setTimeout(function () {
            $('.js-slideshow .owl-next').addClass("active");
          }, 50);
        });
        $('body').on('click', '.js-slideshow .owl-next, .js-slideshow .owl-prev', function () {
          $('.js-slideshow .owl-next').removeClass("active");
        });
        setTimeout(function () {
          $(".js-slideshow .owl-next").addClass("active");
        }, 200);
      },

      shopPlants: function () {
        var currentImage = 1;
        $('.js-carousel-shop-plants').owlCarousel({
          loop: false,
          margin: 0,
          nav: false,
          items: 1,
          autoplay: false,
          animateOut: 'fadeOut',
          animateIn: 'fadeIn'
        });
        $(".js-shop-plants-item").hover(function () {
          var dataId = $(this).attr("data-id");
          $(".js-shop-plants-item").removeClass("active");
          $(this).addClass("active");
          if (dataId != currentImage) {
            currentImage = dataId;
            $('.js-carousel-shop-plants').trigger('to.owl.carousel', dataId - 1);
          }
        });
      },

      exploreCollectionProducts: function () {
        $(".js-explore-collection-products").owlCarousel({
          loop: true,
          margin: 24,
          nav: true,
          navText: ['<svg><circle class="outer" cx="16" cy="16" r="16" transform="rotate(-90, 16, 16)"></circle></svg>', '<svg><circle class="outer" cx="16" cy="16" r="16" transform="rotate(-90, 16, 16)"></circle></svg>'],
          items: 3,
          autoplay: false,
          responsive: {
            0: {
              items: 1
            },
            992: {
              items: 2
            },
            1099: {
              items: 3
            }
          }
        }).on("dragged.owl.carousel", function (event) {
          $('.js-explore-collection-products .owl-next').removeClass("active");
        });
        $('body').on('animationend webkitAnimationEnd oAnimationEnd', '.js-explore-collection-products .owl-next svg circle', function () {
          $('.js-explore-collection-products').trigger('next.owl.carousel');
          $('.js-explore-collection-products .owl-next').removeClass("active");
          setTimeout(function () {
            $('.js-explore-collection-products .owl-next').addClass("active");
          }, 50);
        });
        $('body').on('click', '.js-explore-collection-products .owl-next, .js-explore-collection-products .owl-prev', function () {
          $('.js-explore-collection-products .owl-next').removeClass("active");
        });
        setTimeout(function () {
          $(".js-explore-collection-products .owl-next").addClass("active");
        }, 200);
      },

      lookbook: function () {
        $('.js-carousel-lookbook-products').owlCarousel({
          loop: false,
          margin: 24,
          nav: false,
          dots: true,
          items: 1,
          autoplay: false
        });
        $(".js-lookbook-pin").click(function () {
          if ($(window).outerWidth() > 767) {
            var dataId = $(this).attr("data-id");
            $('.js-carousel-lookbook-products').trigger('to.owl.carousel', dataId - 1)
            return false;
          } else {
            var dataId = $(this).attr("data-id");
            $('.js-carousel-lookbook-products').trigger('to.owl.carousel', dataId - 1);
            $(".js-lookbook-mobile-products").addClass("active");
            $("html, body").animate({ scrollTop: $(".js-lookbook-mobile-products").offset().top - 100 }, "500");
            return false;
          }
        });
      },

      brands: function () {
        $('.js-brands-carousel').owlCarousel({
          loop: true,
          margin: 24,
          nav: false,
          dots: false,
          items: 5,
          autoplay: true,
          responsive: {
            0: {
              items: 2
            },
            768: {
              items: 3
            },
            992: {
              items: 4
            },
            1099: {
              items: 5
            }
          }
        });
      },

      latestNews: function () {
        $(".js-carousel-latest-news").owlCarousel({
          loop: true,
          margin: 24,
          nav: true,
          navText: ['<svg><circle class="outer" cx="16" cy="16" r="16" transform="rotate(-90, 16, 16)"></circle></svg>', '<svg><circle class="outer" cx="16" cy="16" r="16" transform="rotate(-90, 16, 16)"></circle></svg>'],
          items: 3,
          autoplay: false,
          responsive: {
            0: {
              items: 1
            },
            992: {
              items: 2
            },
            1099: {
              items: 3
            }
          }
        }).on("dragged.owl.carousel", function (event) {
          $('.js-carousel-latest-news .owl-next').removeClass("active");
        });
        $('body').on('animationend webkitAnimationEnd oAnimationEnd', '.js-carousel-latest-news .owl-next svg circle', function () {
          $('.js-carousel-latest-news').trigger('next.owl.carousel');
          $('.js-carousel-latest-news .owl-next').removeClass("active");
          setTimeout(function () {
            $('.js-carousel-latest-news .owl-next').addClass("active");
          }, 50);
        });
        $('body').on('click', '.js-carousel-latest-news .owl-next, .js-carousel-latest-news .owl-prev', function () {
          $('.js-carousel-latest-news .owl-next').removeClass("active");
        });
        setTimeout(function () {
          $(".js-carousel-latest-news .owl-next").addClass("active");
        }, 200);
      },


      faq: function () {
        $('.js-faq-carousel').owlCarousel({
          loop: true,
          margin: 50,
          nav: false,
          dots: true,
          items: 1,
          autoplay: false,
        });
      },

      // Blog
      blog: function () {
        var self = this;

        // Search functionality
        $('#blog-search').on('input', function () {
          self.filterBlogArticles();
        });

        // Clear search
        $('#blog-search-clear').on('click', function () {
          $('#blog-search').val('');
          self.filterBlogArticles();
        });

        // Sort functionality
        $('#blog-sort').on('change', function () {
          self.sortBlogArticles();
        });

        // Apply default sort on page load
        self.sortBlogArticles();

        // Infinite scroll
        $(window).scroll(function () {
          if ($(".js-blog-next-page").length > 0) {
            var scrollTop = $(window).scrollTop();
            if (scrollTop > $(".js-blog-next-page").offset().top - $(window).outerHeight() - 100) {
              var href = $(".js-blog-next-page").attr("data-href");
              $(".js-blog-next-page").remove();
              $.ajax({
                url: href,
                type: 'GET'
              }).done(function (data) {
                var newArticles = $(data).find('.js-blog-row').html();
                $('.js-blog-row').append(newArticles);
                // Apply current filters and sorting to new articles
                self.filterBlogArticles();
              })
            }
          }
        });
      },

      filterBlogArticles: function () {
        var searchTerm = $('#blog-search').val().toLowerCase();
        var $articles = $('.blog__row > div').not('.js-blog-next-page');

        $articles.each(function () {
          var $article = $(this);
          var title = $article.data('title') || '';

          if (searchTerm === '' || title.includes(searchTerm)) {
            $article.show();
          } else {
            $article.hide();
          }
        });
      },

      sortBlogArticles: function () {
        var sortValue = $('#blog-sort').val();
        var $container = $('.blog__row');
        var $articles = $container.children().not('.js-blog-next-page');

        $articles.sort(function (a, b) {
          var $a = $(a);
          var $b = $(b);
          var aTitle = $a.data('title') || '';
          var bTitle = $b.data('title') || '';
          var aDate = $a.data('date') || '';
          var bDate = $b.data('date') || '';

          switch (sortValue) {
            case 'title-asc':
              return aTitle.localeCompare(bTitle);
            case 'title-desc':
              return bTitle.localeCompare(aTitle);
            case 'date-asc':
              return aDate.localeCompare(bDate);
            case 'date-desc':
              return bDate.localeCompare(aDate);
            default:
              return 0;
          }
        });

        $container.append($articles);
      },

      // Account
      account: function () {
        $(".js-go-to-forgotten-password").click(function () {
          $(".js-login").addClass("d-none");
          $(".js-forgotten-password").removeClass("d-none");
          return false;
        });
        $(".js-back-to-login").click(function () {
          $(".js-login").removeClass("d-none");
          $(".js-forgotten-password").addClass("d-none");
          return false;
        });
      },

      // Search
      search: function () {
        $(window).scroll(function () {
          if ($(".js-search-next-page").length > 0) {
            var scrollTop = $(window).scrollTop();
            if (scrollTop > $(".js-search-next-page").offset().top - $(window).outerHeight() - 100) {
              var href = $(".js-search-next-page").attr("data-href");
              $(".js-search-next-page").remove();
              $.ajax({
                url: href,
                type: 'GET'
              }).done(function (data) {
                $('.js-search-row').append($(data).find('.js-search-row').html());
              })
            }
          }
        });
      },

      // Collection
      collection: function () {
        $(window).scroll(function () {
          if ($(".js-collection-next-page").length > 0) {
            var scrollTop = $(window).scrollTop();
            if (scrollTop > $(".js-collection-next-page").offset().top - $(window).outerHeight() - 100) {
              var href = $(".js-collection-next-page").attr("data-href");
              $(".js-collection-next-page").remove();
              $.ajax({
                url: href,
                type: 'GET'
              }).done(function (data) {
                $('.js-collection-row').append($(data).find('.js-collection-row').html());
              })
            }
          }
        });
        $(document.body).on('click', '.js-facets-summary', function () {
          var index = $(this).attr("data-index");
          $(".js-collection-filter").toggleClass("active-" + index);
        });
        $(document.body).on('click', '.js-open-mobile-filter', function () {
          $(".js-collection-filter").addClass("active-mobile-filter");
          $("body").addClass("active-filter");
        });
        $(document.body).on('click', '.js-close-mobile-filter', function () {
          $(".js-collection-filter").removeClass("active-mobile-filter");
          $("body").removeClass("active-filter");
        });
      },

      collectionFilter: function () {
        Shopify.queryParams = {};
        Shopify.queryParams.sort_by = $(".js-collection-sort-by").val();
        var tags = [];
        $("input.tag").each(function () {
          if ($(this).is(":checked")) {
            tags.push($(this).attr("value"));
          }
        });
        Shopify.queryParams.constraint = tags.join("+");

        function filterCreateUrl() {
          if (Shopify.queryParams.constraint == '') {
            return $(".js-collection-items").attr("data-url") + "?sort_by=" + Shopify.queryParams.sort_by;
          } else {
            return $(".js-collection-items").attr("data-url") + "/" + Shopify.queryParams.constraint + "?sort_by=" + Shopify.queryParams.sort_by;
          }
        }

        function filterGetContent(url) {
          $.ajax({
            type: "get",
            url: url,
            beforeSend: function () {
              $(".js-collection").addClass("loading");
            },
            success: function (result) {
              var title = result.match("<title>(.*?)</title>")[1];
              History.pushState({
                param: Shopify.queryParams
              }, title, url);
              $(".js-collection").html($(result).find(".js-collection").html());
              $(".js-collection").removeClass("loading");
            },
            error: function () {
              $(".js-collection").removeClass("loading");
            }
          })
        }

        $("input.tag").change(function () {
          var tags = [];
          $("input.tag").each(function () {
            if ($(this).is(":checked")) {
              tags.push($(this).attr("value"));
            }
          });
          Shopify.queryParams.constraint = tags.join("+");
          filterGetContent(filterCreateUrl());
          return false;
        });

        $("body").on("change", ".js-collection-sort-by", function (y) {
          Shopify.queryParams.sort_by = $(".js-collection-sort-by").val();
          filterGetContent(filterCreateUrl());
          return false;
        });

        $("body").on("click", ".js-reset-filters", function (y) {
          var tags = [];
          $("input.tag").each(function () {
            $(this).prop('checked', false);
          });
          Shopify.queryParams.constraint = tags.join("+");
          filterGetContent(filterCreateUrl());
          return false;
        });
      },
      collectionSlider: function () {
        $('.blog-category__image_slider').owlCarousel({
          loop: true,
          margin: 0,
          items: 1,
          dots: true,
          nav: true,
          responsive: {
            0: {
              items: 1,
              margin: 15,
              nav: false,
            },
            560: {
              items: 1,
            }
          }
        });
      },
      collectionSlider2: function () {
        $('.garden-home-slider').owlCarousel({
          items: 5,            // Number of items to show
          loop: true,              // Infinite loop
          autoplay: true,          // Autoplay on
          autoplayTimeout: 3000,   // Autoplay speed (ms)
          autoplaySpeed: 3000,     // Speed of transition (ms) - match with timeout for smoothness
          slideTransition: 'linear', // Smooth linear transition
          autoplayHoverPause: true,
          responsive: {
            0: {
              items: 1.5,
            },
            768: {
              items: 3,
            },
            991: {
              items: 4,
            },
            1100: {
              items: 4.5,
            }
          }
        });
      },
      // Product
      productImages: function () {
        $('.js-slider-product-thumbnails').slick({
          slidesToShow: 5,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          vertical: true,
          verticalSwiping: true,
          responsive: [
            {
              breakpoint: 1199,
              settings: {
                slidesToShow: 4
              }
            },
            {
              breakpoint: 1098,
              settings: {
                slidesToShow: 3
              }
            }
          ]
        });
        $(".js-thumbnail-item").click(function () {
          var index = $(this).attr("data-index");
          $(".js-thumbnail-item").removeClass("active");
          $(this).addClass("active");
          $(".js-main-image").removeClass("active");
          $(".js-main-image[data-index='" + index + "']").addClass("active");
          return false;
        });
        $(".js-product-mobile-images").owlCarousel({
          loop: true,
          margin: 20,
          nav: false,
          dots: true,
          items: 1,
          autoplay: false,
          responsive: {
            0: {
              margin: 15
            },
            768: {
              margin: 20
            }
          }
        });
      },

      productAddToBag: function () {
        $(window).scroll(function () {
          var scrollTop = $(window).scrollTop();
          if (scrollTop > $(".js-product-template").offset().top + $(".js-product-template").outerHeight()) {
            $(".js-scroll-to-top").addClass("active");
          } else {
            $(".js-scroll-to-top").removeClass("active");
          }
        });
        $(".js-scroll-to-top").click(function () {
          $("html, body").animate({ scrollTop: 0 }, "500");
          return false;
        });
      },

      productQuantity: function () {
        $(".js-quantity-up").click(function () {
          var q_val_up = parseInt($(this).parent().find("input").val());
          if (isNaN(q_val_up)) {
            q_val_up = 0;
          }
          $(this).parent().find("input").val(q_val_up + 1).keyup();
          return false;
        });

        $(".js-quantity-down").click(function () {
          var q_val_up = parseInt($(this).parent().find("input").val());
          if (isNaN(q_val_up)) {
            q_val_up = 0;
          }
          if (q_val_up > 1) {
            $(this).parent().find("input").val(q_val_up - 1).keyup();
          }
          return false;
        });
      },

      productRequiredEnquiry: function () {
        $(".js-go-to-contact").click(function () {
          localStorage.setItem('contactMessage', $(this).attr("data-message"));
        });
        $(".js-contact-message").val(localStorage.getItem('contactMessage'));
        localStorage.setItem('contactMessage', '');
      },

      productForm: function () {
        function variants() {
          var data = JSON.parse(document.getElementById('ProductJson').innerHTML);
          var discountData = document.getElementById('ProductDiscountData') ? JSON.parse(document.getElementById('ProductDiscountData').innerHTML) : null;
          var selectCallback = function (variant, selector) {
            var that = $(".product-template");
            if (variant) {
              if (variant.available) {
                $(that).find(".product-template__add-to-cart").removeClass("d-none");
                $(that).find(".product-template__out-of-stock").addClass("d-none");
              } else {
                $(that).find(".product-template__add-to-cart").addClass("d-none");
                $(that).find(".product-template__out-of-stock").removeClass("d-none");
              }
              // Check if discount percentage metafield exists
              var discountPercentage = discountData && discountData.discount_percentage;

              if (discountPercentage) {
                // Calculate discounted price (25% off original)
                var discountDisplay = Math.round(discountPercentage * 100) / 100;
                if (discountDisplay === Math.round(discountDisplay)) {
                  discountDisplay = Math.round(discountDisplay);
                }
                var oneMinusDiscount = 100 - discountPercentage;
                var discountedPrice = Math.round((variant.price * oneMinusDiscount) / 100);

                $(that).find(".price__new").html(Shopify.formatMoney(discountedPrice).replace('.00', ''));
                $(that).find(".price__compare_price").removeClass("d-none").html(Shopify.formatMoney(variant.price).replace('.00', ''));
                $(that).find(".price__discount-badge").removeClass("d-none").html(discountDisplay + "% OFF");
                $(that).find(".price__old").addClass("d-none");
              } else if (variant.compare_at_price > variant.price) {
                $(that).find(".price__old").removeClass("d-none").html(Shopify.formatMoney(variant.compare_at_price).replace('.00', ''));
                $(that).find(".price__new").html(Shopify.formatMoney(variant.price).replace('.00', ''));
                $(that).find(".price__compare_price").addClass("d-none");
                $(that).find(".price__discount-badge").addClass("d-none");
              } else {
                $(that).find(".price__old").addClass("d-none");
                $(that).find(".price__new").html(Shopify.formatMoney(variant.price).replace('.00', ''));
                $(that).find(".price__compare_price").addClass("d-none");
                $(that).find(".price__discount-badge").addClass("d-none");
              }
              if (variant.featured_image !== null) {
                $(".js-thumbnail-item[data-index='" + variant.featured_image.position + "']").click();
                $(".js-product-mobile-images").trigger('to.owl.carousel', variant.featured_image.position - 1)
              }
            } else {
              $(that).find(".product-template__add-to-cart").addClass("d-none");
              $(that).find(".product-template__out-of-stock").removeClass("d-none");
            }
          }
          jQuery(function ($) {
            if ($("#product-select").length > 0) {
              new Shopify.OptionSelectors("product-select", { product: data, onVariantSelected: selectCallback, enableHistoryState: true });
            }
          });
        }

        variants();

        $(".js-open-options").click(function (e) {
          e.stopPropagation();
          var id = $(this).attr("data-id");
          $(".js-option[data-id='" + id + "']").toggleClass("active");
        });

        $(document).click(function (e) {
        if (!$(e.target).closest(".js-option").length) {
            $(".js-option").removeClass("active");
          }
        });

        $(".js-option-value").click(function () {
          var id = $(this).parent().attr("data-id");
          var value = $(this).attr("data-value");
          var option = $(".js-options[data-id='" + id + "']").attr("data-option");
          $(".js-open-options[data-id='" + id + "']").html($(this).html());
          $(".js-option[data-id='" + id + "']").removeClass("active");
          $(".product-template #product-variants select[data-option='" + option + "']").val(value).change();
          return false;
        });

        $(".js-notify-me").click(function () {
          $(".bis-button").click();
          return false;
        });

        $("body").on("click", ".js-add-to-cart", function () {
          var quantity = 1;
          var id = parseInt($(this).attr("data-variant-id"));
          $(this).addClass("is-loading");
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: { id: id, quantity: quantity },
            success: function () {
              soto.refreshCart();
            },
            error: function (response) {
              var errorMessage = response.responseJSON
                ? response.responseJSON.description
                : theme.strings.cartError;
              alert(errorMessage);
              soto.refreshCart();
            }
          });
          return false;
        });


        // ############################################################################
        // ######
        // ######
        // ######                 TEST !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
        // ######
        // ######

        $("body").on("click", ".js-add-to-bag", function () {
          if (!$('.js-add-to-bag').hasClass('add-to-cart_pop')) {
            var quantity = $(".add-to-cart__quantity input[type='number']").val();
            var id = $("#product-select").val();
            $(this).addClass("is-loading");
            $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              dataType: 'json',
              data: { id: id, quantity: quantity },
              success: function (response) {
                soto.refreshCart();
              },
              error: function (response) {
                var errorMessage = response.responseJSON
                  ? response.responseJSON.description
                  : theme.strings.cartError;
                alert(errorMessage);
                soto.refreshCart();
              }
            });
            return false;
          }
        });
      },

      upsellProduct: function () {
        $(".js-carousel-upsell-products").owlCarousel({
          loop: false,
          margin: 15,
          nav: true,
          navText: ['<svg><circle class="outer" cx="16" cy="16" r="16" transform="rotate(-90, 16, 16)"></circle></svg>', '<svg><circle class="outer" cx="16" cy="16" r="16" transform="rotate(-90, 16, 16)"></circle></svg>'],
          dots: false,
          items: 4, //$(".js-carousel-upsell-products").data('item') ? $(".js-carousel-upsell-products").data('item') : 4,
          autoplay: false,
          responsive: {
            0: {
              items: 3,
              margin: 10
            },
            768: {
              items: 5
            },
            992: {
              items: 3
            },
            1099: {
              items: $(".js-carousel-upsell-products").data('item') ? $(".js-carousel-upsell-products").data('item') : 4
            }
          }
        }).on("dragged.owl.carousel", function (event) {
          $('.js-carousel-upsell-products .owl-next').removeClass("active");
        });
        $('body').on('animationend webkitAnimationEnd oAnimationEnd', '.js-carousel-upsell-products .owl-next svg circle', function () {
          $('.js-carousel-upsell-products').trigger('next.owl.carousel');
          $('.js-carousel-upsell-products .owl-next').removeClass("active");
          setTimeout(function () {
            $('.js-carousel-upsell-products .owl-next').addClass("active");
          }, 50);
        });
        $('body').on('click', '.js-carousel-upsell-products .owl-next, .js-carousel-upsell-products .owl-prev', function () {
          $('.js-carousel-upsell-products .owl-next').removeClass("active");
        });
        setTimeout(function () {
          $(".js-carousel-upsell-products .owl-next").addClass("active");
        }, 200);


        $(".js-carousel-deactivate").owlCarousel({
          loop: $(".js-carousel-deactivate").data('loop') ? false : true,
          margin: 25,
          nav: true,
          navText: ['<svg><circle class="outer" cx="16" cy="16" r="16" transform="rotate(-90, 16, 16)"></circle></svg>', '<svg><circle class="outer" cx="16" cy="16" r="16" transform="rotate(-90, 16, 16)"></circle></svg>'],
          dots: false,
          items: 4, //$(".js-carousel-upsell-products").data('item') ? $(".js-carousel-upsell-products").data('item') : 4,
          autoplay: false,
          responsive: {
            0: {
              items: 3
            },
            768: {
              items: 5
            },
            992: {
              items: 3
            },
            1099: {
              items: $(".js-carousel-deactivate").data('item') ? $(".js-carousel-upsell-products").data('item') : 4
            }
          }
        }).on("dragged.owl.carousel", function (event) {
          $('.js-carousel-upsell-products .owl-next').removeClass("active");
        });
        $('body').on('animationend webkitAnimationEnd oAnimationEnd', '.js-carousel-deactivate .owl-next svg circle', function () {
          $('.js-carousel-deactivate').trigger('next.owl.carousel');
          $('.js-carousel-deactivate .owl-next').removeClass("active");
          setTimeout(function () {
            $('.js-carousel-deactivate .owl-next').removeClass("active");
          }, 50);
        });
        $('body').on('click', '.js-carousel-deactivate .owl-next, .js-carousel-deactivate .owl-prev', function () {
          $('.js-carousel-deactivate .owl-next').removeClass("active");
        });
        setTimeout(function () {
          $(".js-carousel-deactivate .owl-next").removeClass("active");
        }, 200);



      },

      relatedProducts: function () {
        if ($(".product-recommendations").length > 0) {
          loadRelatedProducts();
        }
        function loadRelatedProducts() {
          var productRecommendationsSection = document.querySelector(".product-recommendations");
          if (productRecommendationsSection === null) { return; }
          var productId = $(".product-recommendations").attr("data-product-id");
          var limit = $(".product-recommendations").attr("data-limit");
          var requestUrl = "/recommendations/products?section_id=related_products&limit=" + limit + "&product_id=" + productId;
          var request = new XMLHttpRequest();
          request.open("GET", requestUrl);
          request.onload = function () {
            if (request.status >= 200 && request.status < 300) {
              var container = document.createElement("div");
              container.innerHTML = request.response;
              productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
              soto.exploreCollectionProducts();
            }
          };
          request.send();
        }
      },

      productBundlePurchase: function () {
        $("body").on("click", ".js-add-bundle-to-cart", function () {
          var $button = $(this);
          var plantVariantId = $("#product-select").val();
          var upsellVariantIds = $button.attr("data-upsell-variant-ids");
          var quantity = parseInt($button.closest('.add-to-cart__button').siblings('.add-to-cart__quantity').find('input[type="number"]').val()) || 1;

          $button.addClass("is-loading");

          soto.addBundleToCart(plantVariantId, upsellVariantIds, quantity, function () {
            $button.removeClass("is-loading");
          });

          return false;
        });

        $("body").on("change", ".js-upsell-checkbox", function () {
          soto.updateUpsellVariantIds();
        });
      },



      updateUpsellVariantIds: function () {
        var selectedVariantIds = [];

        $(".js-upsell-checkbox:checked").each(function () {
          var variantId = $(this).attr("data-variant-id");
          var variantPrice = $(this).attr("data-price");
          if (variantId) {
            selectedVariantIds.push(variantId);
          }
        });

        var upsellIdsString = selectedVariantIds.join(',');

        if ($(".js-add-bundle-to-cart").length > 0) {
          $(".js-add-bundle-to-cart").attr("data-upsell-variant-ids", upsellIdsString);
        }

        if ($(".add-to-cart_pop").length > 0) {
          $(".add-to-cart_pop").attr("data-id", upsellIdsString);
        }

        soto.updateAddToCartButtonText(selectedVariantIds.length);
      },

      // updateAddToCartButtonText: function(count) {
      //   var $button = $(".add-to-cart_pop");
      //   if ($button.length > 0) {
      //     if (count > 0) {
      //       $button.text("Add plant & " + count + " upsell" + (count > 1 ? "s" : "") + " to bag");
      //     } else {
      //       $button.text("Add plant to bag");
      //     }
      //   }
      // },

      addBundleToCart: function (plantVariantId, upsellVariantIds, quantity, callback) {
        var items = [];

        if (plantVariantId) {
          items.push({
            id: parseInt(plantVariantId),
            quantity: quantity
          });
        }

        if (upsellVariantIds) {
          var upsellIds = [];

          if (typeof upsellVariantIds === 'string') {
            if (upsellVariantIds.indexOf(',') !== -1) {
              upsellIds = upsellVariantIds.split(',');
            } else if (upsellVariantIds !== '') {
              upsellIds = [upsellVariantIds];
            }
          } else if (Array.isArray(upsellVariantIds)) {
            upsellIds = upsellVariantIds;
          }

          upsellIds.forEach(function (variantId) {
            var trimmedId = String(variantId).trim();
            if (trimmedId !== '') {
              items.push({
                id: parseInt(trimmedId),
                quantity: 1
              });
            }
          });
        }

        if (items.length === 0) {
          if (callback) callback();
          return;
        }

        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          dataType: 'json',
          data: { items: items },
          success: function (response) {
            soto.refreshCart();
            if (callback) callback();
          },
          error: function (response) {
            var errorMessage = response.responseJSON
              ? response.responseJSON.description
              : theme.strings.cartError;
            alert(errorMessage);
            soto.refreshCart();
            if (callback) callback();
          }
        });
      },

      // Utilities
      video: function () {
        $('.js-youtube-video').youtube_background();
        $('.js-vimeo-video').vimeo_player();
        if ($('.js-video').length > 0) {
          $(".js-video").each(function () {
            this.controls = false;
            $(this).get(0).play();
          });
        }
        $(".js-open-standard-video a").click(function () {
          $(this).parent().parent().addClass("active");
          return false;
        });
      },

      accordion: function () {
        $(".js-accordion-title").click(function () {
          $(this).parent().parent().find(".js-accordion").removeClass("current");
          $(this).parent().toggleClass("active").addClass("current");
          $(this).parent().parent().find(".js-accordion:not(.current).active .js-accordion-content").slideToggle(500);
          $(this).parent().parent().find(".js-accordion:not(.current).active").removeClass("active");
          $(this).parent().find(".js-accordion-content").slideToggle(500);
        });
        $(".js-accordion.active").each(function () {
          $(this).find(".js-accordion-content").slideToggle(500);
        });
      },

      choosenSelect: function () {
        $(".js-collection-sort-by").chosen();
      },

      refreshCart: function(openCart = true) {
        $.get('/cart', function(data) {
          var $newContent = $(data).find('#cart-content');

          $.getJSON('/cart.js', function(cart) {
            var cartVariantIds = new Set(
              cart.items.map(function(item) {
                return String(item.variant_id);
              })
            );

            $newContent.find('.cart-upsell__item').each(function() {
              var variantId = String($(this).find('.js-add-to-cart').attr('data-variant-id'));
              if (cartVariantIds.has(variantId)) {
                $(this).remove();
              }
            });

            if ($newContent.find('.cart-upsell__item').length === 0) {
              $newContent.find('.cart-upsell').remove();
            }
            $('#cart-content').html($newContent.html());

            if (openCart) {
            $(".js-cart").addClass("active");
            }
            $(".js-add-to-cart, .js-add-to-bag, .js-cart").removeClass("is-loading");
            soto.cartUpsell();
            soto.matchHeight();
          });

          $.getJSON('/cart.js', function(cart) {
            $('.js-cart-item-count').html(cart.item_count).attr("data-count", cart.item_count);
          });
        });
      },

      filterUpsellItems: function() {
        jQuery.getJSON('/cart.js', function(cart) {
          var cartVariantIds = new Set(
            cart.items.map(function(item) {
              return String(item.variant_id);
            })
          );

          $('.cart-upsell__item').each(function() {
            var $item = $(this);
            var variantId = String(
              $item.find('.js-add-to-cart').attr('data-variant-id')
            );
            if (cartVariantIds.has(variantId)) {
              $item.remove();
            }
          });
          if ($('.cart-upsell__item').length === 0) {
            $('.cart-upsell').hide();
          }
        });
      },

      filterUpsellItems: function() {
        jQuery.getJSON('/cart.js', function(cart) {
          // Build a Set of variant IDs currently in the cart
          var cartVariantIds = new Set(
            cart.items.map(function(item) {
              return String(item.variant_id);
            })
          );

          // Hide upsell items whose variant ID is already in cart
          $('.cart-upsell__item').each(function() {
            var $item = $(this);
            var variantId = String(
              $item.find('.js-add-to-cart').attr('data-variant-id')
            );
            if (cartVariantIds.has(variantId)) {
              $item.hide();
            } else {
              $item.show();
            }
          });

          var $upsellBlock = $('.cart-upsell');
          var visibleCount = $upsellBlock.find('.cart-upsell__item:visible').length;
          if (visibleCount === 0) {
            $upsellBlock.hide();
          } else {
            $upsellBlock.show();
          }
        });
      },

      aos: function () {
        AOS.init();
      },

      matchHeight: function () {
        $(".js-match-height-upsell-item").matchHeight();
      },

      attachAddToCartHandler: function () {
        $("body").on("click", ".js-add-to-cart", function () {
          var quantity = 1;
          var id = parseInt($(this).attr("data-variant-id"));
          $(this).addClass("is-loading");
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: { id: id, quantity: quantity },
            success: function () {
              soto.refreshCart();
            },
            error: function (response) {
              var errorMessage = response.responseJSON
                ? response.responseJSON.description
                : theme.strings.cartError;
              alert(errorMessage);
              soto.refreshCart();
            }
          });
          return false;
        });
      }
    }
  })();
})(jQuery);

$(document).ready(function () {
  soto.init();
});

window.addEventListener('pageshow', function (e) {
  var navEntries = (window.performance && performance.getEntriesByType) ? performance.getEntriesByType('navigation') : [];
  var isBackForward = navEntries.length > 0 && navEntries[0].type === 'back_forward';
  if (e.persisted || isBackForward) {
    soto.refreshCart(false);
  }
});

if (window.Shopify.designMode) {
  jQuery(document)
    .on('shopify:section:load', function () {
      soto.init();
    }).on('shopify:section:unload', function () {
      soto.init();
    }).on('shopify:section:select', function () {
      soto.init();
    }).on('shopify:section:deselect', function () {
      soto.init();
    }).on('shopify:block:select', function () {
      soto.init();
    }).on('shopify:block:deselect', function () {
      soto.init();
    });
}


class MyScript {
  constructor(shopifyObj) {
    this.Shopify = shopifyObj;
    this.product = document.querySelector('body.product');
    this.pop_box = this.product.querySelector('.product_pop');
    this.product_pop = this.product.querySelector('.product-pop') ? this.product.querySelectorAll('.product-pop') : null;
    this.add_to_cart = this.product.querySelector('.add-to-cart_pop');
    this.variant = this.product.querySelector('.option__radio');

    !this.variant || this.variant.querySelectorAll('input').forEach(el => el.addEventListener('change', e => this.variantEneble(el)));
    !this.product_pop || this.product_pop.forEach(el => el.addEventListener('click', e => this.showPop(el, e)));
    !this.pop_box || this.pop_box.querySelector('.product_pop__close').addEventListener('click', e => {
      e.preventDefault();
      this.pop_box.classList.remove('active');
      this.product.classList.remove('product--pop');
    });
    !this.pop_box || this.pop_box.querySelector('.product_pop__select').addEventListener('click', e => this.selectProduct(e));
    !this.add_to_cart || this.add_to_cart.addEventListener('click', e => this.addToCart(e));


  }

  variantEneble(el) {
    if (this.product.querySelector('#product-variants')) {
      if (this.product.querySelector('.box__products__select').classList.contains('active')) {
        this.product.querySelector('.box__products__select').querySelector('.remove').click();
      }
      let select = this.product.querySelector('#product-variants select');
      select.value = el.value
      let event = new Event('change');
      select.dispatchEvent(event);
      this.selectSlick(el.dataset.id);
    }

  }

  selectSlick(id) {
    if (this.product.querySelector('.box__prodcutst__actual--variant')) {
      this.product.querySelectorAll(`.box__prodcutst__actual--variant`).forEach(el => el.classList.remove('active'));
      this.product.querySelector(`.box__prodcutst__actual--variant[data-id="${id}"]`).classList.add('active');
    }
  }

  addToCart(e) {
    e.preventDefault();
    let quantity = this.product.querySelector(".add-to-cart__quantity input[type='number']").value,
      id = this.product.querySelector("#product-select").value,
      id_2 = this.add_to_cart.dataset.id ? this.add_to_cart.dataset.id : false;

    this.add_to_cart.classList.add("is-loading");

    const requestData1 = {
      items: [
        {
          id: id,
          quantity: quantity,
        },
      ],
    };

    const requestData2 = {
      items: [
        {
          id: id_2,
          quantity: quantity,
        },
      ],
    };

    this.sendAjaxRequest('/cart/add.js', 'POST', requestData1, (response1) => {

    }, function (error1) {
      console.error('Error while adding product 1 to the cart:', error1);
    });

    if (id_2) {
      setTimeout(() => {
        this.sendAjaxRequest('/cart/add.js', 'POST', requestData2, (response2) => {
          this.add_to_cart.classList.remove("is-loading");
          soto.refreshCart();
        }, function (error1) {
          console.error('Error while adding product 2 to the cart:', error1);
        });

      }, 2000);
    }



  }

  sendAjaxRequest(url, method, data, successCallback, errorCallback) {
    const xhr = new XMLHttpRequest();
    xhr.open(method, url, true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          try {
            const response = JSON.parse(xhr.responseText);
            successCallback(response);
          } catch (parseError) {
            errorCallback(parseError);
          }
        } else {
          errorCallback(xhr.status);
        }
      }
    };
    xhr.send(JSON.stringify(data));
  }

  selectProduct(e) {
    e.preventDefault();
    this.pop_box.classList.remove('active');
    this.product.classList.remove('product--pop');

    var selectedCheckboxes = this.pop_box.querySelectorAll('input:checked');
    var selectedIds = [];
    selectedCheckboxes.forEach(function (checkbox) {
      selectedIds.push(checkbox.value);
    });

    var selectedIdsString = selectedIds.join(',');
    this.product.querySelector('.add-to-cart_pop').dataset.id = selectedIdsString;

    if (this.product.querySelector('.js-add-bundle-to-cart')) {
      this.product.querySelector('.js-add-bundle-to-cart').dataset.upsellVariantIds = selectedIdsString;
    }

    if (selectedCheckboxes.length > 0) {
      this.productInfo(selectedCheckboxes[0]);
    }

  }

  productInfo(el) {
    let item = el.nextElementSibling,
      image = item.querySelector('.item__box__image img'),
      title = item.querySelector('.title'),
      price = item.querySelector('.price'),
      box_select = this.product.querySelector('.box__products__select');
    box_select.dataset.id = el.value;
    box_select.classList.add('active');
    this.product.querySelector('.box__prodcust__pop').classList.add('hidden');
    box_select.querySelector('.image').innerHTML = image.outerHTML;
    box_select.querySelector('.info .top').innerHTML = `<h3>${title.innerHTML}</h3><h4>${price.innerHTML}</h4>`;
    this.renameAddCart();
    box_select.querySelector('.change').addEventListener('click', e => {
      e.preventDefault();
      this.showPop(box_select, e)
    })
    box_select.querySelector('.remove').addEventListener('click', e => {
      e.preventDefault();
      box_select.classList.remove('active');
      this.product.querySelector('.box__prodcust__pop').classList.remove('hidden');
      this.product.querySelector('.add-to-cart_pop').dataset.id = '';
      if (this.product.querySelector('.js-add-bundle-to-cart')) {
        this.product.querySelector('.js-add-bundle-to-cart').dataset.upsellVariantIds = '';
      }
      this.renameAddCart();
    });

  }

  renameAddCart() {
    let btn = this.product.querySelector('.add-to-cart_pop');

    if (btn.dataset.id && btn.dataset.id !== '') {
      var selectedIds = btn.dataset.id.split(',').filter(function (id) { return id.trim() !== ''; });
      var count = selectedIds.length;
      if (count > 0) {
        btn.innerText = 'Add plant & ' + count + ' upsell' + (count > 1 ? 's' : '') + ' to bag';
      } else {
        btn.innerText = 'Add plant to bag';
      }
    } else {
      btn.innerText = 'Add plant to bag';
    }
  }

  showPop(el, e) {
    e.preventDefault();
    if (this.pop_box.classList.contains('product_pop--variants')) {
      this.pop_box.classList.add('active');
      this.product.classList.add('product--pop');
      let item = el.closest('.owl-stage'),
        items = item.querySelector('.content') ? item.querySelectorAll('.content') : false,
        obc = [];

      if (items) {
        items.forEach(itm => {
          obc.push({
            title: itm.querySelector('.upsell-item__product-title a').innerText,
            image: itm.querySelector('.product-pop img'),
            price: itm.querySelector('.upsell-item__price').innerText,
            id_variant: itm.querySelector('.product-pop').dataset.id,
            image_glob: itm.querySelector('.product-pop').dataset.image

          })
        })

        this.createElement(obc);

        var currentlySelected = this.product.querySelector('.add-to-cart_pop').dataset.id;
        if (currentlySelected) {
          var selectedIds = currentlySelected.split(',');
          selectedIds.forEach(function (id) {
            var checkbox = this.pop_box.querySelector(`input[value="${id.trim()}"]`);
            if (checkbox) {
              checkbox.checked = true;
            }
          }.bind(this));
        }

        let im = true;
        this.pop_box.querySelectorAll('.item input').forEach(it => {

          if (it.checked) {
            im = false;
          }
        });
        if (im) {
          let img = this.pop_box.querySelector('.left__image').dataset.src;
          this.pop_box.querySelector('.left__image img').src = img;
        } else {
          let firstChecked = this.pop_box.querySelector('input:checked');
          if (firstChecked) {
            let img = firstChecked.nextElementSibling.dataset.src;
            this.pop_box.querySelector('.left__image img').src = img;
          }
        }

        this.pop_box.querySelectorAll('.item input').forEach(it => it.addEventListener('click', e => {
          if (it.checked) {
            let img = it.closest('label').querySelector('.item__box').dataset.src;
            this.pop_box.querySelector('.left__image').classList.add('left__image--fade');
            setTimeout(() => {
              this.pop_box.querySelector('.left__image img').src = img;
              this.pop_box.querySelector('.left__image').classList.remove('left__image--fade');
            }, 600);
          }
        }))
      }

    } else {
      this.pop_box.querySelector(`input[value="${el.dataset.id}"]`).checked = true;
      this.pop_box.classList.add('active');
      this.product.classList.add('product--pop');

    }
  }
  createElement(obc) {
    let content = '';
    obc.forEach(el => {
      content += `<div class="item"><label>
      <input type="checkbox" class="js-upsell-checkbox" name="upsell_product[]" value="${el.id_variant}" data-variant-id="${el.id_variant}">
      <div class="item__box" data-src="${el.image_glob}">
      <div class="item__box__image">${el.image.outerHTML}</div>
      <h4 class="title">${el.title}</h4>
      <h5 class="price">${el.price}</h5>
      </div>
      </label></div>`
    })
    this.pop_box.querySelector('.product_pop__boxs').innerHTML = content;

  }
}

document.addEventListener("DOMContentLoaded", () => {
  new MyScript(Shopify);
});


/* ============================================================
   Quiz section — step navigation, answer storage, redirect
   ============================================================ */
class SotoQuiz {
  constructor(root) {
    this.root = root;
    this.panels = Array.from(root.querySelectorAll('.js-quiz-panel'));
    this.resultUrl = root.getAttribute('data-result-url') || '/';
    this.answers = {};        // keyed by question_key — for Klaviyo + storage
    this.roleValues = {};     // keyed by role (sunlight/width/length/...) — for filtering
    this.currentIndex = 0;
    this.debug = window.location.search.includes('quizdebug') || window.SOTO_QUIZ_DEBUG === true;

    this.grid = root.querySelector('.js-quiz-products');
    this.emptyMsg = root.querySelector('.js-quiz-empty');
    this.noMatchMsg = root.querySelector('.js-quiz-no-matches');
    this.answersPanel = root.querySelector('.js-quiz-answers');
    this.answersList = root.querySelector('.js-quiz-answers-list');
    this.answersToggle = root.querySelector('.js-quiz-answers-toggle');
    this.answersOverlay = root.querySelector('.js-quiz-answers-overlay');
    this.maxProducts = parseInt((this.grid && this.grid.getAttribute('data-max-products')) || '6', 10);
    this.shopLabel = (this.grid && this.grid.getAttribute('data-shop-label')) || 'Shop Now';
    this.strict = !(this.grid && this.grid.getAttribute('data-strict') === 'false'); // default true

    this.emailInput = root.querySelector('.js-quiz-email');
    this.emailError = root.querySelector('.js-quiz-email-error');
    this.submitBtn = root.querySelector('.js-quiz-submit');

    this.klaviyoKey = root.getAttribute('data-klaviyo-key') || '';
    this.klaviyoEvent = root.getAttribute('data-klaviyo-event') || 'Completed Quiz';
    this.klaviyoListId = root.getAttribute('data-klaviyo-list') || '';

    // Branching state
    this.stylePanelIndex = this.panels.findIndex((p) => this.getRole(p) === 'style');
    this.priorityPanelIndex = this.panels.findIndex((p) => this.getRole(p) === 'priority');
    this.emailPanelIndex = this.panels.findIndex((p) => this.getRole(p) === 'email');
    this.styleSkipped = false;    // true when the Priority answer resolves a category directly
    this.styleMode = 'all';       // 'all' (5 options) or 'colors' (hide evergreen-only)
    this.selectedCategory = '';   // <Style>/tag resolved from Priority / Style — filters within the collection

    this.pool = this.loadPool();  // single flat array of products
    this.allProducts = this.pool;
    this.stateKey = 'sotoQuizState';

    this.lockViewportZoom();
    this.bindEvents();
    this.logInit();
    // Only restore a saved session on a genuine page reload. Arriving fresh — via a link,
    // the close (X) icon, a typed URL, or browser back/forward — starts the quiz clean
    // and discards any previously saved answers (no session is kept across leaving).
    if (this.isReload()) {
      this.restoreState();
    } else {
      this.clearSession();
    }
    // If the quiz page is restored from the back/forward (bfcache), reset to a fresh start.
    window.addEventListener('pageshow', (e) => {
      if (e.persisted) { this.clearSession(); this.restart(); }
    });
    this.panels.forEach((p) => this.layoutGrid(p)); // lay out 2-col grid questions on load
  }

  log(...args) {
    if (this.debug) console.log('[quiz]', ...args);
  }

  isResultPanel(panel) {
    return !!panel && (panel.classList.contains('quiz__panel--result') || panel.getAttribute('data-quiz-step') === 'result');
  }

  // Persist the whole quiz state so a refresh resumes exactly where the shopper was.
  saveState() {
    try {
      const selections = {};
      this.panels.forEach((panel, i) => {
        const sel = panel.querySelector('.js-quiz-option.is-selected');
        const input = panel.querySelector('.js-quiz-text-input');
        const entry = {};
        if (sel) entry.value = sel.getAttribute('data-quiz-value');
        if (input && input.value.trim()) entry.text = input.value.trim();
        if (entry.value != null || entry.text) selections[i] = entry;
      });
      const state = {
        currentIndex: this.currentIndex,
        answers: this.answers,
        roleValues: this.roleValues,
        selectedCategory: this.selectedCategory,
        styleSkipped: this.styleSkipped,
        styleMode: this.styleMode,
        emailDraft: this.emailInput ? this.emailInput.value : '',
        selections,
      };
      sessionStorage.setItem(this.stateKey, JSON.stringify(state));
    } catch (err) { /* storage may be blocked — ignore */ }
  }

  // True only when the current page view is a reload (F5 / pull-to-refresh), so we keep the
  // saved answers; any other navigation type (navigate, back_forward) returns false.
  isReload() {
    try {
      const nav = performance.getEntriesByType('navigation')[0];
      if (nav && nav.type) return nav.type === 'reload';
      if (performance.navigation) return performance.navigation.type === 1;
    } catch (err) { /* ignore */ }
    return false;
  }

  clearSession() {
    try { sessionStorage.removeItem('sotoQuizAnswers'); } catch (err) {}
    try { sessionStorage.removeItem(this.stateKey); } catch (err) {}
  }

  restoreState() {
    let saved;
    try { saved = JSON.parse(sessionStorage.getItem(this.stateKey)); } catch (err) { return; }
    if (!saved || typeof saved !== 'object') return;

    this.answers = saved.answers || {};
    this.roleValues = saved.roleValues || {};
    this.selectedCategory = saved.selectedCategory || '';
    this.styleSkipped = !!saved.styleSkipped;
    this.styleMode = saved.styleMode || 'all';

    // Re-apply each panel's selected option + manual text
    const selections = saved.selections || {};
    this.panels.forEach((panel, i) => {
      const sel = selections[i];
      if (!sel) return;
      if (sel.value != null) {
        panel.querySelectorAll('.js-quiz-option').forEach((b) => {
          if (b.getAttribute('data-quiz-value') === sel.value) b.classList.add('is-selected');
        });
      }
      if (sel.text) {
        const input = panel.querySelector('.js-quiz-text-input');
        const wrap = panel.querySelector('.js-quiz-text-input-wrap');
        const cont = panel.querySelector('.js-quiz-continue');
        if (input) input.value = sel.text;
        if (wrap) wrap.hidden = false;
        if (cont) { cont.hidden = false; cont.disabled = !this.isTextInputValid(input); }
      }
    });

    // Restore the email field (submitted or draft)
    if (this.emailInput) {
      const email = saved.emailDraft || this.answers.email || '';
      if (email) {
        this.emailInput.value = email;
        if (this.submitBtn) this.submitBtn.classList.toggle('is-inactive', !this.isValidEmail(email));
      }
    }

    // Activate the saved panel
    let idx = typeof saved.currentIndex === 'number' ? saved.currentIndex : 0;
    if (idx < 0 || idx > this.panels.length - 1) idx = 0;
    this.panels.forEach((p) => p.classList.remove('is-active'));
    this.currentIndex = idx;
    this.panels[idx].classList.add('is-active');

    if (this.getRole(this.panels[idx]) === 'style') this.applyStyleVisibility(this.panels[idx]);

    // If they refreshed on the results screen, rebuild it (but do NOT re-send to Klaviyo)
    if (this.isResultPanel(this.panels[idx])) {
      this.renderRecommendations();
      this.buildAnswersPanel();
    }

    this.log('restored state →', { idx, answers: this.answers });
  }

  // Effective role: use the Question role setting, but fall back to the question key
  // (sunlight/width/length/priority/style) so the quiz still works if the role wasn't set.
  getRole(panel) {
    if (!panel) return 'standard';
    const role = panel.getAttribute('data-quiz-role') || 'standard';
    if (role !== 'standard') return role;
    const key = (panel.getAttribute('data-quiz-key') || '').trim().toLowerCase();
    if (key === 'sun' || key === 'sunlight') return 'sunlight';
    if (key === 'width') return 'width';
    if (key === 'length') return 'length';
    if (key === 'priority') return 'priority';
    if (key === 'style') return 'style';
    return 'standard';
  }

  loadPool() {
    const script = this.root.querySelector('.js-quiz-product-pool');
    if (!script) return [];
    try {
      const data = JSON.parse(script.textContent);
      return Array.isArray(data) ? data : [];
    } catch (err) {
      this.log('pool: failed to parse product JSON —', err.message);
      return [];
    }
  }

  logInit() {
    this.log('init: products =', this.pool.length,
      '| style panel index =', this.stylePanelIndex, '| klaviyo =', this.klaviyoKey ? 'set' : 'none');
  }

  bindEvents() {
    // Close (X) icon in the header leaves the quiz — clear the saved session so the quiz
    // starts fresh next time (it lives outside the quiz root, so query the document).
    document.querySelectorAll('.header__quiz-close').forEach((btn) => {
      btn.addEventListener('click', () => this.clearSession());
    });

    this.root.querySelectorAll('.js-quiz-option').forEach((btn) => {
      btn.addEventListener('click', (e) => this.onOptionClick(e));
    });

    this.root.querySelectorAll('.js-quiz-start').forEach((btn) => {
      btn.addEventListener('click', () => this.goNext());
    });

    this.root.querySelectorAll('.js-quiz-back').forEach((btn) => {
      btn.addEventListener('click', () => this.goBack());
    });

    this.root.querySelectorAll('.js-quiz-next').forEach((btn) => {
      btn.addEventListener('click', () => this.goNext());
    });

    this.root.querySelectorAll('.js-quiz-text-input').forEach((input) => {
      input.addEventListener('input', (e) => this.onTextInput(e));
      input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.commitTextInput(e.currentTarget, true);
        }
      });
      input.addEventListener('blur', (e) => this.commitTextInput(e.currentTarget, false));
    });

    this.root.querySelectorAll('.js-quiz-continue').forEach((btn) => {
      btn.addEventListener('click', () => {
        const panel = btn.closest('.js-quiz-panel');
        const input = panel && panel.querySelector('.js-quiz-text-input');
        if (input) this.commitTextInput(input, true);
      });
    });

    if (this.emailInput) {
      this.emailInput.addEventListener('input', () => this.onEmailInput());
      this.emailInput.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.onSubmit(e); // validates: proceeds if valid, else shows the red error
        }
      });
    }

    if (this.submitBtn) {
      this.submitBtn.addEventListener('click', (e) => this.onSubmit(e));
    }

    const restart = this.root.querySelector('.js-quiz-restart');
    if (restart) {
      restart.addEventListener('click', () => this.restart());
    }

    // Answers drawer (mobile)
    if (this.answersToggle) this.answersToggle.addEventListener('click', () => this.openAnswers());
    const ansClose = this.root.querySelector('.js-quiz-answers-close');
    if (ansClose) ansClose.addEventListener('click', () => this.closeAnswers());
    if (this.answersOverlay) this.answersOverlay.addEventListener('click', () => this.closeAnswers());
  }

  openAnswers() {
    if (this.answersPanel) this.answersPanel.classList.add('is-open');
    if (this.answersOverlay) { this.answersOverlay.hidden = false; this.answersOverlay.classList.add('is-open'); }
    // Lock the page behind the sheet so the background can't scroll (mobile bottom-sheet).
    this._answersScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    document.body.style.top = -this._answersScrollY + 'px';
    document.body.classList.add('quiz-answers-open');
  }

  closeAnswers() {
    if (this.answersPanel) this.answersPanel.classList.remove('is-open');
    if (this.answersOverlay) { this.answersOverlay.classList.remove('is-open'); this.answersOverlay.hidden = true; }
    if (document.body.classList.contains('quiz-answers-open')) {
      document.body.classList.remove('quiz-answers-open');
      document.body.style.top = '';
      window.scrollTo(0, this._answersScrollY || 0);
    }
  }

  storeAnswer(panel, value) {
    const key = panel.getAttribute('data-quiz-key');
    const role = this.getRole(panel);
    if (key) this.answers[key] = value;
    if (role && role !== 'standard') this.roleValues[role] = value;
  }

  onOptionClick(e) {
    const btn = e.currentTarget;
    const panel = btn.closest('.js-quiz-panel');
    const role = this.getRole(panel);
    const value = btn.getAttribute('data-quiz-value');
    // For Priority/Style options the stored value doubles as the style/tag filter match.
    const category = value || '';
    const branch = btn.getAttribute('data-quiz-branch') || 'none';
    const isTrigger = btn.hasAttribute('data-quiz-triggers-input');

    panel.querySelectorAll('.js-quiz-option').forEach((b) => b.classList.remove('is-selected'));
    btn.classList.add('is-selected');

    const inputWrap = panel.querySelector('.js-quiz-text-input-wrap');
    const input = panel.querySelector('.js-quiz-text-input');
    const continueBtn = panel.querySelector('.js-quiz-continue');
    const nextBtn = panel.querySelector('.js-quiz-next');

    if (isTrigger) {
      this.storeAnswer(panel, value);
      if (nextBtn) nextBtn.hidden = true;
      if (inputWrap) inputWrap.hidden = false;
      if (continueBtn) {
        continueBtn.hidden = false;
        continueBtn.disabled = !(input && input.value.trim());
      }
      if (input) {
        setTimeout(() => input.focus(), 50);
      }
      this.saveState();
      return;
    }

    if (input) input.value = '';
    if (inputWrap) inputWrap.hidden = true;
    if (continueBtn) {
      continueBtn.hidden = true;
      continueBtn.disabled = true;
    }

    this.storeAnswer(panel, value);

    // Branching — Priority decides whether the Style question is shown
    if (role === 'priority') {
      if (branch === 'to_style') {
        this.styleSkipped = false;
        this.styleMode = 'all';
      } else if (branch === 'to_style_colors') {
        this.styleSkipped = false;
        this.styleMode = 'colors';
      } else {
        this.selectedCategory = category;
        this.styleSkipped = true;
      }
      this.log('priority →', { branch, category, styleSkipped: this.styleSkipped, styleMode: this.styleMode });
    } else if (role === 'style') {
      this.selectedCategory = category;
      this.log('style →', { category });
    }

    // All options (including Priority options that jump straight to the email step,
    // e.g. "Pet-safe planting" / "Year-round interest") auto-advance on selection.
    if (nextBtn) nextBtn.hidden = true;

    this.saveState();
    setTimeout(() => this.goNext(), 220);
  }

  onTextInput(e) {
    const input = e.currentTarget;
    this.sanitizeInput(input);
    const panel = input.closest('.js-quiz-panel');
    if (!panel) return;
    const valid = this.isTextInputValid(input);
    const continueBtn = panel.querySelector('.js-quiz-continue');
    if (continueBtn) continueBtn.disabled = !valid;
    // Hide the error while editing once the value becomes valid (don't nag mid-typing).
    const errEl = panel.querySelector('.js-quiz-input-error');
    if (valid) {
      input.classList.remove('is-invalid');
      if (errEl) errEl.hidden = true;
    }
    this.saveState();
  }

  // Valid = has a value, and (if a minimum is set) the entered number is strictly greater
  // than that minimum. The minimum applies regardless of input mode.
  isTextInputValid(input) {
    const value = input.value.trim();
    if (!value) return false;
    const minAttr = input.getAttribute('data-input-min');
    if (minAttr !== null && minAttr !== '') {
      const min = parseFloat(minAttr);
      if (!isNaN(min)) {
        const num = parseFloat(value);
        return !isNaN(num) && num > min;
      }
    }
    return true;
  }

  // Enforce the input mode: 'numeric' → digits only; 'decimal' → digits + one dot.
  // Runs on every input event, so it also cleans pasted text.
  sanitizeInput(input) {
    const mode = input.getAttribute('data-input-mode');
    if (mode !== 'numeric' && mode !== 'decimal') return;

    let cleaned;
    if (mode === 'numeric') {
      cleaned = input.value.replace(/[^0-9]/g, '');
    } else {
      cleaned = input.value.replace(/[^0-9.]/g, '');
      const firstDot = cleaned.indexOf('.');
      if (firstDot !== -1) {
        // keep only the first dot
        cleaned = cleaned.slice(0, firstDot + 1) + cleaned.slice(firstDot + 1).replace(/\./g, '');
      }
    }

    if (cleaned !== input.value) {
      const pos = input.selectionStart - (input.value.length - cleaned.length);
      input.value = cleaned;
      try { input.setSelectionRange(pos, pos); } catch (err) { /* ignore */ }
    }
  }

  commitTextInput(input, advance) {
    const panel = input.closest('.js-quiz-panel');
    if (!panel) return;
    const value = input.value.trim();
    if (!value) return;

    // Block invalid values (e.g. below the minimum) and surface the message.
    if (!this.isTextInputValid(input)) {
      const errEl = panel.querySelector('.js-quiz-input-error');
      if (errEl) errEl.hidden = false;
      input.classList.add('is-invalid');
      const continueBtn = panel.querySelector('.js-quiz-continue');
      if (continueBtn) continueBtn.disabled = true;
      return;
    }

    input.classList.remove('is-invalid');
    this.storeAnswer(panel, value);
    this.saveState();
    if (advance) {
      input.blur(); // drop focus so the keyboard/zoom doesn't carry into the next step
      this.goNext();
    }
  }

  setActive(i) {
    this.panels[this.currentIndex].classList.remove('is-active');
    this.currentIndex = i;
    this.panels[i].classList.add('is-active');
    this.saveState();
    // On mobile the quiz scrolls with the page, so a new panel can open mid-scroll
    // (e.g. after clicking an option near the bottom). Reset to the top so each step
    // starts from its heading, and undo any input-focus zoom from the previous step.
    if (window.matchMedia && window.matchMedia('(max-width: 767px)').matches) {
      this.resetMobileZoom();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  // Disable pinch/auto zoom for the quiz page only. iOS zooms into a focused input and won't
  // zoom back out (you'd have to pinch); locking the viewport here stops it entirely. Scoped
  // to the quiz page (this only runs where a .js-quiz exists), so the rest of the store keeps
  // normal zoom.
  lockViewportZoom() {
    const vp = document.querySelector('meta[name="viewport"]');
    if (vp) vp.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no');
  }

  // Drop focus so the keyboard closes when moving between steps.
  resetMobileZoom() {
    if (document.activeElement && typeof document.activeElement.blur === 'function') {
      document.activeElement.blur();
    }
  }

  goNext() {
    const curRole = this.getRole(this.panels[this.currentIndex]);
    let next = this.currentIndex + 1;

    // Priority answer that picked a category directly → jump straight to the email step,
    // skipping the Style question (works even if the Style panel's role isn't set).
    if (this.styleSkipped && (curRole === 'priority' || curRole === 'style') && this.emailPanelIndex !== -1) {
      next = this.emailPanelIndex;
    } else if (this.styleSkipped && this.stylePanelIndex !== -1 && next === this.stylePanelIndex) {
      next += 1;
    }

    if (next > this.panels.length - 1) return;
    this.setActive(next);
    this.applyStyleVisibility(this.panels[next]);
  }

  goBack() {
    const curRole = this.getRole(this.panels[this.currentIndex]);
    let prev = this.currentIndex - 1;

    // Returning from the email step on a skipped path lands back on the Priority question.
    if (this.styleSkipped && curRole === 'email' && this.priorityPanelIndex !== -1) {
      prev = this.priorityPanelIndex;
    } else if (this.styleSkipped && this.stylePanelIndex !== -1 && prev === this.stylePanelIndex) {
      prev -= 1;
    }

    if (prev < 0) return;
    this.setActive(prev);
  }

  // Hide evergreen-only style options on the "colours" branch path (Beautiful colors).
  // Runs on whatever panel holds the option, so it works even if the Style question's
  // role isn't set. Re-applied on every navigation so changing the Priority answer updates it.
  applyStyleVisibility(panel) {
    if (!panel) return;
    panel.querySelectorAll('.js-quiz-option').forEach((b) => {
      if (b.getAttribute('data-quiz-branch') !== 'evergreen_only') return;
      const hide = this.styleMode === 'colors';
      b.hidden = hide;
      if (hide) b.classList.remove('is-selected');
    });
    this.layoutGrid(panel);
  }

  // 2-column "grid" layout: if the number of VISIBLE options is odd, make the last
  // visible one span the full width. Counts only visible items (ignores hidden ones).
  layoutGrid(panel) {
    if (!panel) return;
    panel.querySelectorAll('.quiz__options--grid').forEach((grid) => {
      const opts = Array.from(grid.querySelectorAll('.quiz__option--grid')).filter((o) => !o.hidden);
      opts.forEach((o) => o.classList.remove('is-full'));
      if (opts.length > 0 && opts.length % 2 === 1) {
        opts[opts.length - 1].classList.add('is-full');
      }
    });
  }

  /* ---------- Email step ---------- */
  isValidEmail(v) {
    const email = String(v || '').trim().toLowerCase();
    // Strict validation: overall length cap, a single @, a valid local part, and a domain
    // with a real TLD of 2+ letters (rejects "a@b", "x@google", "x@google.c", trailing dots).
    if (!email || email.length > 254) return false;
    if (email.indexOf('..') !== -1) return false;          // no consecutive dots
    const re = /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*\.[a-z]{2,}$/;
    if (!re.test(email)) return false;
    const at = email.indexOf('@');
    const local = email.slice(0, at);
    if (local.length > 64 || local.charAt(0) === '.' || local.charAt(local.length - 1) === '.') return false;

    // Typo guard for popular providers. ".con"/".cob" etc. are valid-LOOKING TLDs the regex
    // can't catch, so for known provider names we reject an explicit list of broken ".com"
    // typos — while still ALLOWING real TLDs like ".co" and ".com" (so gmail.co is fine but
    // gmail.con is not). Any non-provider/custom domain is unaffected.
    const domain = email.slice(at + 1);
    const provider = domain.split('.')[0];
    const tld = domain.split('.').pop();
    const POPULAR = ['gmail', 'googlemail', 'yahoo', 'hotmail', 'outlook', 'live', 'icloud', 'aol', 'protonmail', 'proton'];
    const BAD_TLDS = ['con', 'cob', 'comm', 'cpm', 'ocm', 'cmo', 'vom', 'xom', 'om', 'cm', 'clm', 'coom', 'cin', 'vcom'];
    if (POPULAR.indexOf(provider) !== -1 && BAD_TLDS.indexOf(tld) !== -1) return false;

    // Reject common misspellings of popular provider NAMES (catches gmial.com, gnail.com,
    // etc. — cases the rule above misses because the provider name itself is wrong). Any
    // other real domain (company/custom) still passes.
    const TYPO_DOMAINS = [
      'gmial.com', 'gmai.com', 'gmal.com', 'gmaill.com', 'gnail.com', 'gmailo.com', 'gamil.com',
      'yaho.com', 'yahooo.com', 'yhoo.com',
      'hotmial.com', 'hotmai.com', 'hotmil.com', 'hotmaill.com',
      'outlok.com', 'outook.com', 'outloo.com',
      'iclould.com', 'iclud.com',
    ];
    if (TYPO_DOMAINS.indexOf(domain) !== -1) return false;

    return true;
  }

  onEmailInput() {
    const valid = this.isValidEmail(this.emailInput.value);
    // Keep the button grayed (but clickable) until the address is valid.
    if (this.submitBtn) this.submitBtn.classList.toggle('is-inactive', !valid);
    // Clear the red error state once the address becomes valid again.
    if (valid) {
      this.emailInput.classList.remove('is-invalid');
      if (this.emailError) this.emailError.hidden = true;
    }
    this.saveState();
  }

  onSubmit(e) {
    if (e) e.preventDefault();
    const email = this.emailInput ? this.emailInput.value.trim() : '';
    if (!this.isValidEmail(email)) {
      // Surface the red message, redden the field, and focus it.
      if (this.emailError) this.emailError.hidden = false;
      if (this.emailInput) { this.emailInput.classList.add('is-invalid'); this.emailInput.focus(); }
      return;
    }
    if (this.emailError) this.emailError.hidden = true;
    if (this.emailInput) { this.emailInput.classList.remove('is-invalid'); this.emailInput.blur(); }
    this.answers.email = email;

    this.log('submit: answers =', { ...this.answers }, '| roles =', { ...this.roleValues });
    try {
      sessionStorage.setItem('sotoQuizAnswers', JSON.stringify(this.answers));
    } catch (err) { /* storage may be blocked — ignore */ }

    this.renderRecommendations();
    this.buildAnswersPanel();
    this.sendToKlaviyo(email);
    this.goNext();
    console.log('[quiz] finished');
  }

  // Build the "answers you provided" summary on the result screen from what the shopper
  // actually selected. Reads each answered question panel in order; skips skipped/unanswered.
  buildAnswersPanel() {
    if (!this.answersList) return;
    const esc = (s) => String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');

    const rows = [];
    this.panels.forEach((panel) => {
      const role = this.getRole(panel);
      if (role === 'email' || !panel.getAttribute('data-quiz-key')) return; // skip email/intro/result
      const label = panel.getAttribute('data-quiz-label') || '';
      const display = this.getPanelDisplayAnswer(panel);
      if (!display) return; // unanswered or skipped (e.g. the Style question on a direct path)
      rows.push(
        `<div class="quiz__answer-row">
          <span class="quiz__answer-label">${esc(label)}</span>
          <span class="quiz__answer-value">${esc(display)}</span>
        </div>`
      );
    });

    this.answersList.innerHTML = rows.join('');
    if (this.answersPanel) this.answersPanel.hidden = rows.length === 0;
    if (this.answersToggle) this.answersToggle.hidden = rows.length === 0;
  }

  // The shopper-facing answer for a panel: typed value (with template) → personalised
  // answer → option title → stored value.
  getPanelDisplayAnswer(panel) {
    const textInput = panel.querySelector('.js-quiz-text-input');
    const selected = panel.querySelector('.js-quiz-option.is-selected');
    if (textInput && textInput.value.trim()) {
      const typed = textInput.value.trim();
      const tpl = textInput.getAttribute('data-answer-template');
      return (tpl && tpl.trim()) ? tpl.replace(/\[value\]/g, typed) : typed;
    }
    if (selected) {
      const custom = selected.getAttribute('data-quiz-answer');
      if (custom && custom.trim()) return custom.trim();
      const titleEl = selected.querySelector('.quiz__option-title');
      return titleEl ? titleEl.textContent.trim() : (selected.getAttribute('data-quiz-value') || '');
    }
    return '';
  }

  // Rich, human-readable properties for Klaviyo: keyed by the question label
  // (e.g. "Sunlight": "Full sun"), plus the raw stored value (e.g. "sunlight value": "Sunny"),
  // a one-line summary, and the recommended product titles.
  collectAnswerProperties() {
    const props = {};
    const summary = [];
    this.panels.forEach((panel) => {
      const role = this.getRole(panel);
      if (role === 'email' || !panel.getAttribute('data-quiz-key')) return;
      const display = this.getPanelDisplayAnswer(panel);
      if (!display) return;
      const key = panel.getAttribute('data-quiz-key');
      const label = (panel.getAttribute('data-quiz-label') || role || key || '').trim();
      const stored = (this.answers[key] != null) ? this.answers[key] : '';
      if (label) {
        props[label] = display;                       // e.g. "Sunlight": "Full sun"
        summary.push(`${label}: ${display}`);
      }
      if (role && role !== 'standard' && stored) {
        props[`${role} value`] = stored;              // e.g. "priority value": "Soto Pet" (for segmenting)
      }
    });
    if (summary.length) props['Quiz Answers'] = summary.join(' | ');
    if (this.lastRecommended && this.lastRecommended.length) {
      props['Recommended Products'] = this.lastRecommended.join(', ');
    }
    return props;
  }

  /* ---------- Filtering pipeline: collection → sun → width → style/priority → length variant ---------- */
  matchesCategory(product, category) {
    const cat = String(category).trim().toLowerCase();
    if (!cat) return true;
    const style = String(product.style || '').trim().toLowerCase();
    if (style === cat) return true;
    const tags = (product.tags || []).map((t) => String(t).trim().toLowerCase());
    return tags.indexOf(cat) !== -1;
  }

  filterProducts() {
    const base = this.allProducts.slice();

    const sun = String(this.roleValues.sunlight || '').trim().toLowerCase();
    const width = String(this.roleValues.width || '').trim().toLowerCase();
    const category = this.selectedCategory || '';
    const lengthAns = this.roleValues.length || '';

    let filtered = base;
    if (category) filtered = filtered.filter((p) => this.matchesCategory(p, category));
    if (sun) filtered = filtered.filter((p) => String(p.sun || '').trim().toLowerCase() === sun);
    if (width) filtered = filtered.filter((p) => String(p.width || '').trim().toLowerCase() === width);

    let noMatch = false;
    if (!filtered.length) {
      noMatch = true;
      // Strict (default): show nothing rather than non-matching products.
      // Non-strict: relax to the category alone — but NEVER cross into other categories.
      if (!this.strict) {
        filtered = category ? base.filter((p) => this.matchesCategory(p, category)) : base;
      }
    }

    const over7 = this.isOverSeven(lengthAns);
    filtered.forEach((p) => { p._variant = this.pickVariant(p, lengthAns, over7); });

    this.log('filter:', { category, sun, width, length: lengthAns, over7, matched: filtered.length, noMatch });
    return { list: filtered.slice(0, this.maxProducts), noMatch, over7 };
  }

  isOverSeven(ans) {
    const s = String(ans || '');
    const n = parseFloat(s.replace(/[^0-9.]/g, ''));
    return /more|over/i.test(s) || (!isNaN(n) && n > 7);
  }

  // Extract the first number from a string ("2", "2m", "2 metres", "Length: 2") → 2
  parseLen(s) {
    const m = String(s == null ? '' : s).match(/\d+(?:\.\d+)?/);
    return m ? parseFloat(m[0]) : NaN;
  }

  // The numeric length of a variant — checks every option value and the title, so it works
  // regardless of which option holds the length or how it's labelled.
  variantLength(v) {
    const candidates = [v.length, v.o1, v.o2, v.o3, v.title];
    for (let i = 0; i < candidates.length; i += 1) {
      const n = this.parseLen(candidates[i]);
      if (!isNaN(n)) return n;
    }
    return NaN;
  }

  pickVariant(product, lengthAns, over7) {
    const variants = product.variants || [];
    if (!variants.length) return null;
    const byAvail = (a, b) => (b.available ? 1 : 0) - (a.available ? 1 : 0);

    // "More than 7m" (or no length answer) → largest available variant
    if (over7 || !lengthAns) {
      return variants.slice().sort((a, b) => byAvail(a, b) || (this.variantLength(b) - this.variantLength(a)))[0];
    }

    const target = this.parseLen(lengthAns);
    let picked = null;
    if (!isNaN(target)) {
      // Exact length match — prefer an in-stock variant
      const exact = variants.filter((v) => this.variantLength(v) === target).sort(byAvail);
      if (exact.length) picked = exact[0];
      if (!picked) {
        // Nearest length among variants that actually have a number
        const numeric = variants.filter((v) => !isNaN(this.variantLength(v)));
        if (numeric.length) {
          picked = numeric.slice().sort((a, b) =>
            (Math.abs(this.variantLength(a) - target) - Math.abs(this.variantLength(b) - target)) || byAvail(a, b))[0];
        }
      }
    }
    if (!picked) picked = variants.slice().sort(byAvail)[0]; // last resort
    if (this.debug) {
      this.log('pickVariant', product.title, '| answer:', lengthAns, '→ target:', target,
        '| variants:', variants.map((v) => `${this.variantLength(v)}${v.available ? '' : '(x)'}`).join(','),
        '| picked:', picked && (picked.length || picked.title));
    }
    return picked;
  }

  renderRecommendations() {
    if (!this.grid) return;

    if (!this.allProducts.length) {
      if (this.emptyMsg) this.emptyMsg.hidden = false;
      this.log('render: no products in pool — source collection not configured / empty.');
      return;
    }

    const { list, noMatch, over7 } = this.filterProducts();
    this.lastRecommended = list.map((p) => p.title); // for the Klaviyo "Recommended Products" property
    this.grid.innerHTML = list.map((p) => this.buildCardHtml(p, p._variant, over7)).join('');

    // The pool has products, so "store empty" never applies here. Show the no-match
    // message whenever the filters matched nothing (strict) or relaxed to closest picks.
    if (this.noMatchMsg) this.noMatchMsg.hidden = !noMatch;
    if (this.emptyMsg) this.emptyMsg.hidden = true;
  }

  buildCardHtml(p, variant, over7) {
    const esc = (s) => String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');

    const url = (variant && variant.id) ? `${p.url}?variant=${variant.id}` : p.url;
    const price = (variant && variant.price) ? variant.price : p.price;
    const img = p.image
      ? `<img src="${esc(p.image)}" alt="${esc(p.title)}" loading="lazy">`
      : '';
    const subtitle = (p.subtitle != null && String(p.subtitle).trim() !== '')
      ? `<p class="quiz__product-subtitle">"${esc(p.subtitle)}"</p>`
      : '';

    return `
      <article class="quiz__product js-quiz-product">
        <a href="${esc(url)}" class="quiz__product-img">${img}</a>
        <h3 class="quiz__product-title">${esc(p.title)}</h3>
        ${subtitle}
        <a href="${esc(url)}" class="quiz__cta quiz__cta--small">
          <span class="quiz__cta-label">${esc(this.shopLabel)}</span>
          <span class="quiz__cta-sep" aria-hidden="true">|</span>
          <span class="quiz__cta-price">${esc(price)}</span>
        </a>
      </article>
    `;
  }

  /* ---------- Klaviyo (client-side, fire-and-forget) ---------- */
  sendToKlaviyo(email) {
    if (!this.klaviyoKey) {
      console.warn('[quiz][klaviyo] No public API key set in the theme editor — sync skipped.');
      return;
    }

    const props = this.collectAnswerProperties();

    const payload = {
      data: {
        type: 'event',
        attributes: {
          properties: props,
          metric: { data: { type: 'metric', attributes: { name: this.klaviyoEvent } } },
          profile: { data: { type: 'profile', attributes: { email, properties: props } } },
        },
      },
    };

    const url = `https://a.klaviyo.com/client/events/?company_id=${encodeURIComponent(this.klaviyoKey)}`;

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify(payload),
      keepalive: true,
    })
      .then((r) => {
        if (r.ok || r.status === 202) {
          console.log('[quiz][klaviyo] ✓ event sent — HTTP %s. Check the profile in Klaviyo.', r.status);
        } else {
          console.error('[quiz][klaviyo] ✗ request rejected — HTTP %s (check the public key / event name).', r.status);
          r.text().then((t) => t && console.error('[quiz][klaviyo] response:', t)).catch(() => {});
        }
      })
      .catch((err) => console.error('[quiz][klaviyo] ✗ network/CORS error —', err));

    // Also subscribe the shopper to a Klaviyo list (with the answers as profile properties).
    this.subscribeToList(email, props);
  }

  // Adds the email + answers to a Klaviyo list (client-side "Create Client Subscription").
  // Requires a list ID in the theme editor; otherwise it's skipped.
  subscribeToList(email, props) {
    if (!this.klaviyoKey || !this.klaviyoListId) return;

    const payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Quiz',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email,
                properties: props,
              },
            },
          },
        },
        relationships: { list: { data: { type: 'list', id: this.klaviyoListId } } },
      },
    };

    const url = `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(this.klaviyoKey)}`;
    console.log('[quiz][klaviyo] subscribing %s to list %s', email, this.klaviyoListId);

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify(payload),
      keepalive: true,
    })
      .then((r) => {
        if (r.ok || r.status === 202) {
          console.log('[quiz][klaviyo] ✓ subscribed to list — HTTP %s.', r.status);
        } else {
          console.error('[quiz][klaviyo] ✗ list subscribe rejected — HTTP %s (check the list ID).', r.status);
          r.text().then((t) => t && console.error('[quiz][klaviyo] response:', t)).catch(() => {});
        }
      })
      .catch((err) => console.error('[quiz][klaviyo] ✗ list subscribe network/CORS error —', err));
  }

  restart() {
    this.answers = {};
    this.roleValues = {};
    this.selectedCategory = '';
    this.styleSkipped = false;
    this.styleMode = 'all';
    this.clearSession();

    this.root.querySelectorAll('.js-quiz-option').forEach((b) => { b.classList.remove('is-selected'); b.hidden = false; });
    this.root.querySelectorAll('.js-quiz-text-input').forEach((i) => { i.value = ''; i.classList.remove('is-invalid'); });
    this.root.querySelectorAll('.js-quiz-text-input-wrap').forEach((w) => { w.hidden = true; });
    this.root.querySelectorAll('.js-quiz-continue').forEach((b) => { b.hidden = true; b.disabled = true; });
    if (this.emailInput) { this.emailInput.value = ''; this.emailInput.classList.remove('is-invalid'); }
    if (this.emailError) this.emailError.hidden = true;
    if (this.submitBtn) this.submitBtn.classList.add('is-inactive');
    if (this.grid) this.grid.innerHTML = '';
    if (this.noMatchMsg) this.noMatchMsg.hidden = true;
    if (this.emptyMsg) this.emptyMsg.hidden = true;
    if (this.answersList) this.answersList.innerHTML = '';
    if (this.answersPanel) this.answersPanel.hidden = true;
    if (this.answersToggle) this.answersToggle.hidden = true;
    this.closeAnswers();

    this.panels.forEach((p) => p.classList.remove('is-active'));
    this.currentIndex = 0;
    this.panels[0].classList.add('is-active');
    this.root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-quiz').forEach((el) => new SotoQuiz(el));
});

document.addEventListener("DOMContentLoaded", () => {
  new MyScript(Shopify);
});

/* ==========================================================================
   Collections V2 — scroll-snap carousel + overflow-aware USP strip
   Markup: sections/collections_v2.liquid  Styles: assets/theme.scss.css
   ========================================================================== */

class SotoCollectionsV2Carousel {
  constructor(media) {
    this.media = media;
    this.track = media.querySelector('[data-cv2-track]');
    this.dotsWrap = media.querySelector('[data-cv2-dots]');
    this.arrowsWrap = media.querySelector('[data-cv2-arrows]');
    this.prevBtn = media.querySelector('[data-cv2-prev]');
    this.nextBtn = media.querySelector('[data-cv2-next]');

    if (!this.track) return;

    this.slides = Array.from(this.track.querySelectorAll('[data-cv2-slide]'));
    this.index = 0;
    this.ticking = false;

    if (this.slides.length < 2) {
      this.track.removeAttribute('tabindex');
      return;
    }

    this.buildDots();
    if (this.arrowsWrap) this.arrowsWrap.hidden = false;

    this.onScroll = this.onScroll.bind(this);
    this.track.addEventListener('scroll', this.onScroll, { passive: true });

    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.step(-1));
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.step(1));

    this.sync();
  }

  buildDots() {
    if (!this.dotsWrap) return;
    const label = this.track.getAttribute('aria-label') || 'photo';

    this.dots = this.slides.map((slide, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'collections-v2__dot';
      dot.setAttribute('aria-label', 'Show ' + label + ' ' + (i + 1) + ' of ' + this.slides.length);
      dot.addEventListener('click', () => this.goTo(i));
      this.dotsWrap.appendChild(dot);
      return dot;
    });

    this.dotsWrap.hidden = false;
  }

  /* Measured from rects so padding, borders and positioning can't skew the maths. */
  goTo(index) {
    const target = this.slides[Math.max(0, Math.min(index, this.slides.length - 1))];
    if (!target) return;
    const delta = target.getBoundingClientRect().left - this.track.getBoundingClientRect().left;
    this.track.scrollTo({ left: this.track.scrollLeft + delta, behavior: 'smooth' });
  }

  step(direction) {
    this.goTo(this.index + direction);
  }

  onScroll() {
    if (this.ticking) return;
    this.ticking = true;
    window.requestAnimationFrame(() => {
      this.sync();
      this.ticking = false;
    });
  }

  sync() {
    const left = this.track.scrollLeft;
    const trackLeft = this.track.getBoundingClientRect().left;
    let closest = 0;
    let smallest = Infinity;

    this.slides.forEach((slide, i) => {
      const distance = Math.abs(slide.getBoundingClientRect().left - trackLeft);
      if (distance < smallest) {
        smallest = distance;
        closest = i;
      }
    });

    this.index = closest;

    if (this.dots) {
      this.dots.forEach((dot, i) => {
        const active = i === closest;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    const maxScroll = this.track.scrollWidth - this.track.clientWidth;
    if (this.prevBtn) this.prevBtn.disabled = left <= 1;
    if (this.nextBtn) this.nextBtn.disabled = left >= maxScroll - 1;
  }
}

function sotoCollectionsV2Init() {
  document.querySelectorAll('.collections-v2__media').forEach((media) => {
    new SotoCollectionsV2Carousel(media);
  });

  document.querySelectorAll('[data-cv2-usp]').forEach((strip) => {
    new SotoCollectionsV2Ticker(strip);
  });
}

/* The header pins itself (.js-header.fixed) once the page scrolls past the
   promo bar, so a plain anchor jump parks the target underneath it. Scroll
   manually and subtract the pinned header's height. */
function sotoCollectionsV2HeaderOffset() {
  const container = document.querySelector('.js-header-container');
  if (!container) return 0;
  return container.getBoundingClientRect().height;
}

document.addEventListener('click', (event) => {
  const cta = event.target.closest && event.target.closest('.collections-v2__cta');
  if (!cta) return;

  const href = cta.getAttribute('href') || '';
  if (href.charAt(0) !== '#' || href.length < 2) return;

  const target = document.getElementById(href.slice(1));
  if (!target) return;

  event.preventDefault();

  const top =
    target.getBoundingClientRect().top +
    window.pageYOffset -
    sotoCollectionsV2HeaderOffset();

  window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
});

/* Marquee for the USP strip. Mobile-only, matching the Figma mobile frame:
   from 640px up the strip is the static centred row and never animates.
   The ticker also stands down whenever the claims already fit. */
class SotoCollectionsV2Ticker {
  constructor(strip) {
    this.strip = strip;
    this.viewport = strip.querySelector('.collections-v2__usp-viewport');
    this.track = strip.querySelector('[data-cv2-usp-track]');
    this.list = strip.querySelector('[data-cv2-usp-list]');
    this.toggle = strip.querySelector('[data-cv2-usp-toggle]');

    if (!this.viewport || !this.track || !this.list) return;

    this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.mobile = window.matchMedia('(max-width: 639px)');
    this.paused = false;
    this.sync = this.sync.bind(this);

    if (this.toggle) {
      this.toggle.addEventListener('click', () => this.setPaused(!this.paused));
    }

    /* Touch/pointer users get a pause mechanism by tapping the strip (WCAG 2.2.2). */
    this.viewport.addEventListener('pointerdown', () => {
      if (this.strip.classList.contains('is-static')) return;
      this.setPaused(!this.paused);
    });

    this.sync();

    if (typeof ResizeObserver === 'function') {
      /* The list is observed too: a font swap changes its width without
         ever resizing the viewport, and that flips the fits/ticker decision. */
      const observer = new ResizeObserver(this.sync);
      observer.observe(this.viewport);
      observer.observe(this.list);
    } else {
      window.addEventListener('resize', this.sync);
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(this.sync);
    }
    window.addEventListener('load', this.sync);

    if (this.reduced.addEventListener) {
      this.reduced.addEventListener('change', this.sync);
    }
    if (this.mobile.addEventListener) {
      this.mobile.addEventListener('change', this.sync);
    }
  }

  setPaused(paused) {
    this.paused = paused;
    this.strip.classList.toggle('is-paused', paused);
    if (this.toggle) this.toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
  }

  sync() {
    const style = window.getComputedStyle(this.list);
    const listWidth = this.list.getBoundingClientRect().width;
    /* One copy plus its seam margin — the distance the marquee travels. The
       seam only exists while ticking, so it must not count toward the fit test. */
    const copyWidth = listWidth + parseFloat(style.marginRight || 0);

    /* Measure the content box: clientWidth includes the viewport padding, and
       comparing against that lets the row overflow into the inset and clip. */
    const vpStyle = window.getComputedStyle(this.viewport);
    const available =
      this.viewport.clientWidth -
      parseFloat(vpStyle.paddingLeft || 0) -
      parseFloat(vpStyle.paddingRight || 0);

    const fits = listWidth <= available + 1;
    const canAnimate = this.mobile.matches && !this.reduced.matches;

    /* Three modes: centred (fits), ticker (mobile overflow), swipe (the rest). */
    this.strip.classList.toggle('is-static', fits);
    this.strip.classList.toggle('is-scroll', !fits && !canAnimate);

    if (fits || !canAnimate) {
      const scrolls = !fits;
      if (scrolls) {
        this.viewport.setAttribute('tabindex', '0');
        this.viewport.setAttribute('role', 'group');
        this.viewport.setAttribute('aria-label', 'Why shop with Soto');
      } else {
        this.viewport.removeAttribute('tabindex');
        this.viewport.removeAttribute('role');
        this.viewport.removeAttribute('aria-label');
      }
      if (this.paused) this.setPaused(false);
      return;
    }

    this.viewport.removeAttribute('tabindex');
    this.viewport.removeAttribute('role');
    this.viewport.removeAttribute('aria-label');

    /* Constant ~45px/s regardless of how much copy the merchant enters. */
    this.track.style.setProperty('--cv2-usp-duration', (copyWidth / 45).toFixed(2) + 's');
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', sotoCollectionsV2Init);
} else {
  sotoCollectionsV2Init();
}

/* Shopify theme editor: rebuild carousels when the section is re-rendered. */
document.addEventListener('shopify:section:load', (event) => {
  if (!event.target || !event.target.querySelector) return;
  event.target.querySelectorAll('.collections-v2__media').forEach((media) => {
    new SotoCollectionsV2Carousel(media);
  });
  event.target.querySelectorAll('[data-cv2-usp]').forEach((strip) => {
    new SotoCollectionsV2Ticker(strip);
  });
});
